import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { BannerLayout, BannerMessage, BannerButton } from '@wix/da-ds/pkg/Banner/lego';
import CloseIcon from '@wix/da-ds/pkg/Icons/16x16/Close';
import { usePWABanner } from './usePWABanner';

import s from './PWABanner.scss';

const PWABanner: React.FC = () => {
  const { t } = useTranslation();
  const { dismiss, registerPushSubscription, isSubscribed, isHidden } = usePWABanner();

  if (isHidden || isSubscribed) {
    return null;
  }

  return (
    <BannerLayout
      size="big"
      className={s['root']}
      body={[
        <IconButton
          icon={CloseIcon}
          aria-label={t('common.close')}
          key="midfix-icon"
          size="small"
          iconClassName={s['icon']}
          onClick={dismiss}
        />,
        <BannerMessage
          key="message-after-icon"
          weight="bld"
          className={s['your-typography-colors']}
        >
          <div className={s['title']}>{t('pwa.banner.title')}</div>
          <div className={s['subtitle']}>{t('pwa.banner.subtitle')}</div>
        </BannerMessage>,
      ]}
      postfix={
        <BannerButton variant="solid" onClick={registerPushSubscription}>
          {t('pwa.confirmationPopup.button.cta')}
        </BannerButton>
      }
    />
  );
};
PWABanner.displayName = 'PWABanner';

export default PWABanner;
